import { HOTEL_FRAGMENT } from '@app/model/hotel/service/HotelGraphQLFragments';
import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';

export const FIND_HOTEL_QUERY: GraphQL = {
    name: "findHotelById",
    gql: gql`
        ${HOTEL_FRAGMENT}
        query findHotelById($id: Long!) {
            findHotelById(id: $id) {
                ...HotelFields
            }
        }
    `
}

export const ADD_HOTEL_FROM_BOOKING_URL_MUTATION: GraphQL = {
    name: "addHotelFromBookingUrl",
    gql: gql`
        ${HOTEL_FRAGMENT}
        mutation addHotelFromBookingUrl($url: String!) {
            addHotelFromBookingUrl(url: $url) {
                ...HotelFields
            }
        }
    `
}

export const ADD_HOTEL_FROM_AIRBNB_URL_MUTATION: GraphQL = {
    name: "addHotelFromAirbnb",
    gql: gql`
        ${HOTEL_FRAGMENT}
        mutation addHotelFromAirbnb($url: String!) {
            addHotelFromAirbnb(url: $url) {
                ...HotelFields
            }
        }
    `
}
export const FIND_HOTEL_SUGGESTIONS_MUTATION: GraphQL = {
    name: "findHotelSuggestions",
    gql: gql`
        ${HOTEL_FRAGMENT}
        query findHotelSuggestions($hotelId: Long!) {
            findHotelSuggestions(hotelId: $hotelId) {
                hotel {
                    ...HotelFields
                }
                suggestions {
                    hotel {
                        ...HotelFields
                    }
                    distance
                    reviewScoreAverage
                }
            }
        }
    `
}